exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".withs[data-v-10d1570a]{width:50%}.noBox[data-v-10d1570a] .el-form-item__content{margin-left:0 !important}.tempBox[data-v-10d1570a] .el-input-number--mini{width:100px !important}", ""]);

// exports
